import { Component, Input, OnInit } from '@angular/core';

// services
import { PolicyActionService } from '@open-portal-app/core/services/policy-action.service';

export interface IDataInterface {
  productClass?: string,
  policyTypeLabel?: string,
  policyNumber?: string
}

export interface IActionListInterface {
  label: string;
  icon: string;
  action: string;
  type: string;
}

@Component({
  selector: 'app-policy-action',
  templateUrl: './policy-action.component.html',
  styleUrls: ['./policy-action.component.scss']
})
export class PolicyActionComponent implements OnInit {
  @Input() data!: any;
  actionList: IActionListInterface[] = [];

  constructor(
    private policyActionService: PolicyActionService
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.actionList = this.policyActionService.getActions(this.data);
    }
  }

  handleAction(action: string, type: string): void {
    switch (action) {
      case 'goToSupport':
        this.policyActionService.goToSupport(this.data, type);
        break;
      case 'goToClaim':
        this.policyActionService.goToClaims(this.data);
        break;
      default:
        break;
    }
  }
}
